import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { notifyOpener } from "./oauthPopupBridge";
import linkedInUtils from "../settings/ConnectedAccounts/LinkedInAccounts/common/linkedInUtils";

const LinkedInOAuthCallback = () => {
  const [done, setDone] = useState(false);

  useEffect(() => {
    (async () => {
      const accountId = new URLSearchParams(window.location.search).get(
        "account_id"
      );
      if (accountId) {
        await linkedInUtils.markOAuthConnectionStarted(accountId);
      }
      notifyOpener({ type: "LINKEDIN_OAUTH_POPUP_DONE" });
      setDone(true);
      // The opener closes this popup when it hears the signal above. If the
      // sign-in round-trip severed that link, try to close from here too;
      // Chrome may refuse, so the page says what happened either way.
      try {
        window.close();
      } catch (e) {
        /* refused: the message below covers it */
      }
    })();
  }, []);

  return (
    <div className="pageClass">
      <div className="pageCont">
        <div className="connectAppSection">
          <div>
            {done
              ? "All done here. You can close this window and go back to Salesgear."
              : "Connecting your LinkedIn account…"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(LinkedInOAuthCallback);
export { LinkedInOAuthCallback };
